"use strict";

exports.__esModule = true;
exports.IFrameFields = IFrameFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactDebounceInput = require("react-debounce-input");
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for IFrameElement.
 */
function IFrameFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "IFrameFields.urlTemplate.label",
      defaultMessage: "URL Template"
    }),
    helperText: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "IFrameFields.urlTemplate.helperText.intro",
      defaultMessage: "The URL to use for the iframe. This URL can include the following variables:"
    }), /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("strong", null, "{device_id}"), " ", /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "IFrameFields.urlTemplate.helperText.device_id",
      defaultMessage: "The id of the device."
    })), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("strong", null, "{device_name}"), " ", /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "IFrameFields.urlTemplate.helperText.device_name",
      defaultMessage: "The name of the device."
    })), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("strong", null, "{start_date}"), " ", /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "IFrameFields.urlTemplate.helperText.start_date",
      defaultMessage: "The start date of the reporting period."
    })), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("strong", null, "{end_date}"), " ", /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "IFrameFields.urlTemplate.helperText.end_date",
      defaultMessage: "The end date of the reporting period."
    }))))
  }, /*#__PURE__*/_react["default"].createElement(_reactDebounceInput.DebounceInput, {
    element: _core.InputGroup,
    type: "url",
    minLength: 2,
    debounceTimeout: 300,
    value: element.props.urlTemplate || "",
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "urlTemplate", e.target.value);
    }
  }));
}